import React, { useEffect, useState } from 'react';
import { Button, Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import axios from 'axios';
import { host, url } from '../../../config/common';
import Loader from '../../utils/loader';
import CustomPagination from './pagination/customPagination';
import CoolEventCard from '../../utils/coolEventCard';
import { useNavigate } from 'react-router-dom';

const CoolEvents = () => {
    const [searchInput, setSearchInput] = useState("");
    const [airportList, setAirportList] = useState([]);
    const [coolEventsData, setCoolEventsData] = useState({
        list: [],
        loading: false,
        currentPage: "1",
        totalPages: 1,
        totalRecords: 1,
    });
    const [eventParams, setEventParams] = useState({
        page: 1,
        limit: 21,
    });
    const [showloader, setShowloader] = useState(false);
    let navigate = useNavigate();

    const fetchCoolEvents = async () => {
        try {
            setShowloader(true)
            let fetchedEventData = await axios({
                method: 'get',
                headers: { 'x-access-token': JSON.parse(localStorage.getItem('user'))?.token ? JSON.parse(localStorage.getItem('user')).token : "" },
                url: `${host}${url.getShareAnUpdate}?search=${searchInput}&page=${eventParams.page}&limit=${eventParams.limit}&eventName=cool_event`
            });
            if (fetchedEventData?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/")
            }
            if (fetchedEventData) {
                setShowloader(false);
                setCoolEventsData((v) => ({
                    ...v,
                    list: fetchedEventData?.data?.data?.records,
                    loading: false,
                    currentPage: fetchedEventData?.data?.data?.currentPage,
                    totalPages: fetchedEventData?.data?.data?.totalPages,
                    totalRecords: fetchedEventData?.data?.data?.totalRecords,
                }));
            }
        } catch (error) {
            console.log({ error });
            if (error?.response?.status == 401) {
                localStorage.removeItem("user")
                return navigate("/")
            }
        }
    }

    const searchCoolEvents = async (e) => {
        try {
            setEventParams((v) => ({ ...v, page: 1 }));
            fetchCoolEvents();
        } catch (error) {
            console.log({ error });
        }
    }

    const handlePageChange = (e, page) => {
        setEventParams((v) => ({ ...v, page: page }));
    };

    const paginationProps = {
        currentPage: coolEventsData?.currentPage,
        totalPages: coolEventsData?.totalPages,
        totalRecords: coolEventsData?.totalRecords,
        handlePageChange,
    };

    useEffect(() => {
        fetchCoolEvents();
    }, [eventParams]);

    return (
        <div style={{ padding: "0px 20px" }}>
            <Row>
                <Col>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <h3>Cool Event Requests</h3>
                    </div>
                </Col>
            </Row>
            <Row>
                <div>
                    <Row>
                        <Col xs="7">
                            <Form onSubmit={(e) => { e.preventDefault(); searchCoolEvents() }}>
                                <InputGroup style={{ width: "500px", float: "left", marginBottom: "1%" }}>
                                    <FormControl
                                        placeholder="Search by event name"
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        value={searchInput}
                                    />
                                    <Button variant="outline-primary" type='submit'>
                                        Search
                                    </Button>
                                </InputGroup>
                            </Form>
                        </Col>
                    </Row>
                    <Loader show={showloader} />
                    <Row style={{ height: "82vh", overflow: "scroll " }}>
                        <Col>
                            {coolEventsData?.list?.length > 0
                                ?
                                <>
                                    <Row style={{ marginTop: "20px" }}>
                                        {
                                            coolEventsData?.list?.map((item) =>
                                                <Col sm="4" key={item._id}>
                                                    <CoolEventCard coolEventsData={item} refreshData={() => fetchCoolEvents()} airportList={airportList} />
                                                </Col>
                                            )
                                        }
                                    </Row>
                                    <CustomPagination props={{ paginationProps }} />
                                </>
                                :
                                <Row style={{ marginTop: "20px" }}>No Records Found</Row>
                            }

                        </Col>
                    </Row>
                </div>
            </Row>
        </div>
    );
}

export default CoolEvents;
